import { dataUserMobileSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserMobileSolid = /*#__PURE__*/createIcon(dataUserMobileSolid)
export default IconUserMobileSolid
